import { useState, useEffect } from 'react';
import ApiService from '../../../../services/api'
import DOMPurify from "dompurify";

const CookiePolicy = () => {
  

  const [cookiePolicy, setCookiePolicy] = useState('');

  useEffect(() => {
      const fetchCookiePolicy = async () => {
        try {
          const res = await ApiService.getLegal();
          setCookiePolicy(res.cookie_policy); 
        } catch (err) {
          console.error('Errore nel recupero della policy dei cookie:', err);
        }
      };
      fetchCookiePolicy();
    },[]);

    return (
        <div>
            <h2 style={{marginBottom: "50px", marginTop: "10px"}}>Cookie Policy</h2>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(cookiePolicy || "") }} />
        </div>

    );

  }

export default CookiePolicy;